export default {"src":"/_next/static/media/display-code.90586886.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};